// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** Batch Delete SysMenu (批量删除菜单表) 根据ID列表批量删除菜单表 DELETE /api/sys/menu/batch-delete */
export async function batchDeleteSysMenu(
  body: string[],
  options?: { [key: string]: any }
) {
  return request<API.ResultBoolean>("/api/sys/menu/batch-delete", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** Create SysMenu (创建菜单表) 创建新菜单表 POST /api/sys/menu/create */
export async function createSysMenu(
  body: API.SysMenu,
  options?: { [key: string]: any }
) {
  return request<API.ResultBoolean>("/api/sys/menu/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** Delete SysMenu (删除菜单表) 根据ID删除菜单表 DELETE /api/sys/menu/delete/${param0} */
export async function deleteSysMenu(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteSysMenuParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultBoolean>(`/api/sys/menu/delete/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Get SysMenu Detail (获取菜单表详情) 获取菜单表详情 GET /api/sys/menu/detail/${param0} */
export async function getSysMenuDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSysMenuDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultSysMenu>(`/api/sys/menu/detail/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Get Max Sort (获取最大排序值) 获取菜单表最大排序值，如果数据不存在返回10，存在则返回最大值+10 GET /api/sys/menu/max-sort */
export async function getMaxSort(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getMaxSortParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultInteger>("/api/sys/menu/max-sort", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Get SysMenu List (获取菜单表分页列表) 获取菜单表列分页列表 GET /api/sys/menu/page */
export async function getSysMenu4Page(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSysMenu4PageParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultPageSysMenu>("/api/sys/menu/page", {
    method: "GET",
    params: {
      ...params,
      arg0: undefined,
      ...params["arg0"],
    },
    ...(options || {}),
  });
}

/** Get Menu Tree (获取菜单树形结构) 获取所有菜单的树形结构，按照sort字段升序排序 GET /api/sys/menu/tree */
export async function getMenuTree(options?: { [key: string]: any }) {
  return request<API.ResultListSysMenuTreeVo>("/api/sys/menu/tree", {
    method: "GET",
    ...(options || {}),
  });
}

/** Update SysMenu (更新菜单表) 更新菜单表信息 PUT /api/sys/menu/update/${param0} */
export async function updateSysMenu(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.updateSysMenuParams,
  body: API.SysMenu,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultBoolean>(`/api/sys/menu/update/${param0}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** Get User Menu Tree (获取用户授权菜单树形结构) 根据用户ID获取该用户的授权菜单树形结构，通过用户角色关联查询用户有权限的菜单 GET /api/sys/menu/user-tree */
export async function getUserMenuTree(options?: { [key: string]: any }) {
  return request<API.ResultListSysMenuTreeVo>("/api/sys/menu/user-tree", {
    method: "GET",
    ...(options || {}),
  });
}
